// Modules
import axios from 'axios'

// Helpers
import { getAuthorizationHeader, getTeamHeader } from 'helpers/authentication'

// Constants
import { SINGLE_SIGN_ON_URL } from 'constants/environment'

// Helper: Network > Request SSO token
async function requestSSOToken () {
	try {
		const response = await axios({
			headers: {
				...getAuthorizationHeader(),
				...getTeamHeader()
			},
			method: 'GET',
			url: SINGLE_SIGN_ON_URL
		})
		if (!!response) return response
		else return { error: 'client.ssoTokenFetchingError' }
	} catch (error) {
		console.error(error)
		return { error: 'client.ssoTokenFetchingError' }
	}
}

// Export
export {
	requestSSOToken
}
